import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Select from "react-select";
import InputField from "../../utils/InputField";

class LocationEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            companies: [],
            inputError: [],
            inputParams: {
                id: this.props.location.id,
                companyId: this.props.location.company_id,
                name: this.props.location.name,
            }
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.saveEditLocation = this.saveEditLocation.bind(this);
        this.getInput = this.getInput.bind(this);
        this.editSelect = this.editSelect.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();

    }

    requestCompaniesForUser() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    enterSaveEditLocation(event) {

        if (event.keyCode === 13) {
            this.saveEditLocation();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditLocation() {

        const inputParams = this.state.inputParams;

        if (inputParams && inputParams.name) {
            const params = {
                action: 'saveCompanyLocation',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                id: inputParams.id,
                companyId: inputParams.companyId,
                name: inputParams.name,
            };

            const callback = function(res) {
                this.resetInputError();

                if (res.success) {
                    alert(this.translate(res.msgKey));

                    this.props.changeView();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        } else {
            this.setInputError(['name']);
        }

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    render() {

        if (!this.state.inputParams) return <LoadingSplash />;

        const companies = this.state.companies;
        const disabledCompanySelection = (companies.length === 1);

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('locationSettings')}</h1>
                </nav>

                <div className="col-xs-12 col-lg-4">
                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('id')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="id"
                                            value={this.state.inputParams.id}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('name')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="name"
                                            className={this.checkInputError('name')}
                                            value={this.state.inputParams.name}
                                            isRequired={true}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('company')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="companyId"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('companyId')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={companies}
                                            value={companies.find(o => String(o.value) === String(this.state.inputParams.companyId)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            disabled={disabledCompanySelection}
                                            onChange={(event) => this.editSelect(event, 'companyId')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan webElement">&nbsp;</td>

                                    <td className="text-left">
                                        <a className="formButton" onClick={() => this.props.changeView()}>
                                            {this.translate('cancel')}
                                        </a>

                                        <a className="formButton" onClick={() => this.saveEditLocation()} onKeyDown={(event) => this.enterSaveEditLocation(event)}>
                                            {this.translate('save')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default LocationEditContainer;